import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapTogglerSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcaptoggler: {
      group: 'inline',
      inline: true,
      content: 'inline*',
      definingForContent: true,
      attrs: {
        targets: { default: undefined },
      },
      parseDOM: [{
        tag: 'MadCap\\:toggler',
        getAttrs(dom) {
          return getSchemaAttrs(dom, ['targets']);
        },
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:toggler'
    }
  } satisfies Record<string, NodeSpec>;
}
